module.exports = __webpack_public_path__ + "img/tr-edit-icon.f638fe19.svg";